import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './Banner.css';

const BannerForHome = () => {
  const [banners, setBanners] = useState([]);
  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch banners data
  useEffect(() => {
    fetch('https://healthkeywordresearch01-5ec078e699df.herokuapp.com/banner')
      .then((res) => res.json())
      .then((info) => setBanners(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch blog post data when pageSlug changes


  return (


    <>

      {
        banners.map(b => b.pageSlug === '' && <section id="hero-5" className="bg-scroll hero-section division">
          <div className="container white-color">
            {/* HERO CONTENT */}
            <div className="row d-flex align-items-center">
              {/* HERO TEXT */}
              <div className="col-lg-5">
                <div className="hero-5-txt wow fadeInRight" data-wow-duration="2.5s" data-wow-delay="0.4s">
                  {/* Title */}
                  <h3 className="h3-xl">{b.bannerHeading}</h3>
                  {/* Text */}
                  <p className="p-xl">{b.bannerDetails}</p>
                  {/* Buttons */}
                  <div className="hero-5-btns">
                    {/* Button */}
                    <a href={b.buttonURL} className="btn btn-yellow tra-white-hover mr-15">{b.buttonText}</a>
                    {/* Button */}

                  </div>
                </div>
              </div>	 {/* END HERO TEXT */}
              {/* HERO IMAGE */}
              <div className="col-lg-7 mt-5 p-5">
                <div className="video-preview mb-80 wow fadeInUp" data-wow-delay="0.4s">
                  <a className="video-popup3" href={b.buttonURLTwo}>  {/* Change the link HERE!!! */}
                    {/* Play Icon */}
                   
                    {/* Preview Image */}
                    <img className="img-fluid" src={b.imageOne} alt="content-image" />
                  </a>
                </div>
              </div>
            </div>	{/* END HERO CONTENT */}
            {/* HERO BOXES */}
            <div id="hero-5-boxes">
              <div className="row">
              </div>
            </div>	{/*END HERO BOXES */}
          </div>     {/* End container */}
        </section>)}
    </>
  );
};

export default BannerForHome;
